import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/auth";
import { useNavigate } from "react-router-dom";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import {
  PartnerEcgDeviceListDatagrid,
  PartnerCustomerAssignEcgDeviceForm,
  PartnerCustomerUnassignEcgDeviceForm,
} from "../../components";
import HomeHealthIcon from "../../svg/Property 1=home_health_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg";
import PersonIcon from "../../svg/Property 1=person_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24 1.svg";
import StethoscopeIcon from "../../svg/Property 1=stethoscope_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";

export default function PartnerEcgDevicePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [tabSelectedIndex, setTabSelectedIndex] = useState(0);

  const [title, setTitle] = useState("");
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);
  const [fetchTrigger, setFetchTrigger] = useState(0);

  const breadcrumbItemsBase = [{ label: "Home", path: "/", active: false }];

  const tabTitle = [
    "ECG Device List",
    "Assign Device",
    "Unassign Device",
  ];

  function onTitleClick(e) {
    var itemIndex = e.itemIndex;
    setTabSelectedIndex(itemIndex);
    setTitle(tabTitle[itemIndex]);
    setBreadcrumbItems(
      breadcrumbItemsBase.concat({
        label: tabTitle[itemIndex],
        path: "#",
        active: true,
      })
    );
    setFetchTrigger((prevTrigger) => prevTrigger + 1);
  }

  useEffect(() => {
    if (user.usertype === "CP" || user.usertype === "DIST") {
      setTitle(tabTitle[0]);
      setBreadcrumbItems(
        breadcrumbItemsBase.concat({
          label: tabTitle[0],
          path: "#",
          active: true,
        })
      );
    } else {
      navigate("/");
    }
  }, []);

  return (
    <React.Fragment>
      <Breadcrumb title={title} items={breadcrumbItems} />
      <TabPanel
        className={"content-block dx-card responsive-paddings"}
        swipeEnabled={false}
        scrollByContent={true}
        showNavButtons={true}
        onTitleClick={onTitleClick}
      >
        <Item title="ECG Device List" icon={HomeHealthIcon}>
          <PartnerEcgDeviceListDatagrid fetchTrigger={fetchTrigger} />
        </Item>

        <Item title="Assign Device" icon={StethoscopeIcon}>
          <PartnerCustomerAssignEcgDeviceForm fetchTrigger={fetchTrigger} />
        </Item>

        <Item title="Unassign Device" icon={PersonIcon}>
          <PartnerCustomerUnassignEcgDeviceForm fetchTrigger={fetchTrigger} />
        </Item>
      </TabPanel>
    </React.Fragment>
  );
}